import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";

export const Route = createFileRoute("/_authenticated/admin/bousala/smart")({
  head: () => ({
    meta: [{ title: "البوصلة الذكية — إدارة" }, { name: "robots", content: "noindex" }],
  }),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: () => (
    <div dir="rtl" className="space-y-5">
      <Outlet />
    </div>
  ),
});
